import { put, call, cancelled } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchReportFactorySuccessVPO, fetchReportFactoryRequestVPO, fetchReportFactoryFailureVPO } from "./report-factory";
import { fetchReportFactory } from "../../api/api";

export function* handleFetchReportFactoryVPO(action: ReturnType<typeof fetchReportFactoryRequestVPO>): SagaIterator {
  const controller = new AbortController();
  try {
    const params = action.payload;
    const data = yield call(fetchReportFactory, params, controller.signal);
    yield put(fetchReportFactorySuccessVPO({ data, params }));
  } catch (error) {
    yield put(fetchReportFactoryFailureVPO(error.message));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}
